import { render, staticRenderFns } from "./BranchComponent.vue?vue&type=template&id=fd153872&scoped=true"
import script from "./BranchComponent.vue?vue&type=script&lang=js"
export * from "./BranchComponent.vue?vue&type=script&lang=js"
import style0 from "./BranchComponent.vue?vue&type=style&index=0&id=fd153872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd153872",
  null
  
)

export default component.exports